module.exports = __webpack_public_path__ + "img/vignette.ddd52d9e.webp";